import { render, staticRenderFns } from "./SignaturesView.vue?vue&type=template&id=35058ba4"
import script from "./SignaturesView.vue?vue&type=script&lang=js"
export * from "./SignaturesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports